// Global Instructions Rule Applied!
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { List } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faBriefcase, faAddressBook, faChartPie, faHandshake, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { BROWSE_MODULES, getDescriptor } from '../lib/listDescriptors.ts'
import { browsePath } from '../lib/routes.ts'

const MODULE_ICON: Record<string, any> = {
  companies: faBuilding,
  deals: faBriefcase,
  contacts: faAddressBook,
  funds: faChartPie,
  prospects: faHandshake
}

/**
 * Browse hub: one tappable row per module that has a mobile list, driven by the same
 * descriptors the lists use. Read-only; no per-module counts (each would cost a fetch).
 */
export function BrowseScreen(): React.JSX.Element {
  const navigate = useNavigate()

  return (
    <div style={{ padding: 12 }}>
      <List
        dataSource={BROWSE_MODULES}
        rowKey={(m) => m}
        renderItem={(m) => {
          const descriptor = getDescriptor(m)
          if (!descriptor) return null
          return (
            <List.Item
              onClick={() => navigate(browsePath(m))}
              style={{
                cursor: 'pointer',
                background: '#fff',
                borderRadius: 8,
                marginBottom: 8,
                paddingLeft: 14,
                paddingRight: 14
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%' }}>
                <FontAwesomeIcon icon={MODULE_ICON[m] ?? faChevronRight} style={{ color: '#1890ff', fontSize: 18, width: 22 }} />
                <span style={{ flex: 1, fontSize: 16 }}>{descriptor.label}</span>
                <FontAwesomeIcon icon={faChevronRight} style={{ color: 'rgba(0,0,0,0.25)' }} />
              </div>
            </List.Item>
          )
        }}
      />
    </div>
  )
}

export default BrowseScreen
